import { Autocomplete, Box, ListItem, ListItemText, Stack, TextField } from "@mui/material"
import { useTranslation } from "react-i18next"
import { StyledListItem, StyledListItemText } from "shared/styled/General"

const DashboardSelect = (props) => {
  const { vehiclesResult, setChosenVehicle, setActiveIssueReports } = props
  const { t } = useTranslation()
  const filteredVehicles = vehiclesResult.data?.filter((vehicle) => !vehicle.archived) || []

  return (
    <StyledListItem>
      <Box>
        <StyledListItemText
          style={{ paddingBottom: "8px" }}
          primary={t("global.select_vehicle", "Select vehicle")}
        />
      </Box>

      <Autocomplete
        sx={{ width: "100%" }}
        id="vehicleId"
        options={filteredVehicles}
        getOptionLabel={(option) => option.internnumber && `${option.regNumber} (${option.internnumber})`}
        value={filteredVehicles.find((i) => i.id === i.vehicleId)}
        getOptionSelected={(option, value) => {
          return option.id === value.id
        }}
        onChange={(e, value) => {
          setChosenVehicle(value)
          setActiveIssueReports(value)
        }}
        renderOption={(props, option) => (
          <li {...props}>
            <Stack direction="row" spacing={2} justifyContent="space-between">
              <Box sx={{ fontWeight: 600, minWidth: "100px" }}>{option.regNumber}</Box>
              <Box sx={{ opacity: 0.6 }}>{option.internnumber}</Box>
            </Stack>
          </li>
        )}
        renderInput={(params) => <TextField {...params} variant="outlined" name="vehicleId" />}
      />
    </StyledListItem>
  )
}

export default DashboardSelect
